// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import KBLogo from './KBLogo';
// import axios from 'axios';

// import { load } from '@cashfreepayments/cashfree-js';

// const FormPage = () => {
//   const navigate = useNavigate();

//   const [view, setView] = useState('form'); 
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
//   const [includeWebinar, setIncludeWebinar] = useState(false);
//   const [errors, setErrors] = useState({});

//   const [prices, setPrices] = useState({
//     whatsapp: 99,
//     webinar: 149,
//     isEnabled: true
//   });

//   // 1. Fetch Pricing and Settings from Backend
//   useEffect(() => {
//     const fetchSettings = async () => {
//       try {
//         const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://kshitizfits.onrender.com";
//         const res = await axios.get(`${API_BASE}/api/settings`);
//         if (res.data) {
//           setPrices({
//             whatsapp: res.data.livePrice || 99,
//             webinar: res.data.webinarPrice || 149,
//             isEnabled: res.data.isPaymentEnabled
//           });

//           if (res.data.isPaymentEnabled === false) {
//             alert("Payments are currently disabled.");
//             navigate('/');
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching pricing", err);
//       }
//     };
//     fetchSettings();
//   }, [navigate]);

//   // 2. Meta Pixel Tracking for PageView and AddToCart
//   useEffect(() => {
//     if (window.fbq) {
//       window.fbq('track', 'PageView'); 
//       window.fbq('track', 'AddToCart', {
//         content_name: 'Fitness Community + Webinar Access',
//         content_ids: ['community_01'],
//         content_type: 'product',
//         value: prices.whatsapp,
//         currency: 'INR'
//       });
//       console.log("🚀 Meta Pixel: AddToCart Triggered");
//     }
//   }, [prices.whatsapp]);

//   const total = includeWebinar ? prices.whatsapp + prices.webinar : prices.whatsapp;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.phone.trim() || !/^[0-9]{10}$/.test(formData.phone.trim())) newErrors.phone = 'Enter 10-digit phone';
//     if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) newErrors.email = 'Valid email required';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const initializePayment = async (isUpgraded) => {
//     setIsLoading(true);

//     const finalPrice = isUpgraded ? (prices.whatsapp + prices.webinar) : prices.whatsapp;
//     const productName = isUpgraded ? 'Community + Webinar Access' : 'Community Access Only';

//     // Meta Pixel Checkout Tracking
//     if (window.fbq) {
//       window.fbq('track', 'InitiateCheckout', {
//         content_name: productName, 
//         value: finalPrice,          
//         currency: 'INR',
//         num_items: 1
//       });
//       console.log(`🚀 Meta Pixel: InitiateCheckout for ${productName} at ₹${finalPrice}`);
//     }

//     try {
//       const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://kshitizfits.onrender.com";
      
//       // Load Cashfree SDK (Production Mode)
//       const cashfree = await load({
//         mode: "production" 
//       });

//       // Fetch Payment Session from Backend
//       const response = await axios.post(`${API_BASE}/api/verify-and-pay`, {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         includeWebinar: isUpgraded
//       });

//       if (response.data.payment_session_id) {
//         let checkoutOptions = {
//           paymentSessionId: response.data.payment_session_id,
//           redirectTarget: "_self", // Keeps the flow within the same tab for better tracking
//         };

//         // Open Cashfree Overlay
//         cashfree.checkout(checkoutOptions).then((result) => {
//           if (result.error) {
//             console.error("Cashfree SDK Error:", result.error);
//             alert("Payment session expired or failed. Please try again.");
//             setIsLoading(false);
//           }
//         });
//       } else {
//         alert('Payment failed to initialize.');
//         setIsLoading(false);
//       }
//     } catch (error) {
//       console.error("Payment Error:", error);
//       alert('Network error or Gateway busy. Please try again.');
//       setIsLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     if (!includeWebinar) {
//       if (window.fbq) {
//         window.fbq('trackCustom', 'ViewedUpsell');
//       }
//       setView('upsell'); 
//     } else {
//       initializePayment(true);
//     }
//   };

//   const handleUpsellChoice = async (upgrade) => {
//     setIsLoading(true); 
//     setIncludeWebinar(upgrade);
//     await initializePayment(upgrade);
//   };

//   return (
//     <div className="bg-charcoal min-h-screen py-8 px-4 text-white">
//       <header className="max-w-2xl mx-auto flex items-center justify-between mb-8">
//         <button 
//           onClick={() => view === 'form' ? navigate('/') : setView('form')} 
//           disabled={isLoading}
//           className="text-zinc-400 hover:text-white transition-colors disabled:opacity-50 touch-manipulation cursor-pointer"
//         >
//           ← Back
//         </button>
//         <KBLogo size={40} />
//       </header>

//       <div className="max-w-2xl mx-auto">
//         {view === 'form' && (
//           <div className="animate-fade-in-up bg-dark-grey rounded-3xl p-6 md:p-10 border border-zinc-800 shadow-2xl">
//             <h1 className="text-2xl font-bold mb-8">Join the Community</h1>
//             <form onSubmit={handleSubmit}>
//               <div className="space-y-4 mb-8">
//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Full Name</label>
//                   <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="Your Name" />
//                   {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
//                 </div>
//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Phone Number</label>
//                   <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="10 Digit Number" />
//                   {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
//                 </div>
//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Email Address</label>
//                   <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="example@email.com" />
//                   {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
//                 </div>
//               </div>

//               <h2 className="text-lg font-semibold mb-4 text-zinc-300">Select Package</h2>

//               <div className="flex items-center bg-zinc-900/50 rounded-2xl p-4 border border-zinc-800 mb-3 opacity-90">
//                 <div className="w-6 h-6 rounded-md bg-emerald-accent/20 border border-emerald-accent/50 flex items-center justify-center mr-4">
//                   <div className="w-2 h-2 bg-emerald-accent rounded-full"></div>
//                 </div>
//                 <div className="flex-1">
//                   <p className="font-medium">WhatsApp Community Access</p>
//                 </div>
//                 <span className="font-bold">₹{prices.whatsapp}</span>
//               </div>

//               <div 
//                 onClick={() => !isLoading && setIncludeWebinar(!includeWebinar)}
//                 className={`flex items-center rounded-2xl p-4 border-2 cursor-pointer touch-manipulation transition-all ${includeWebinar ? 'bg-emerald-accent/5 border-emerald-accent' : 'bg-zinc-900/50 border-zinc-800 hover:border-zinc-600'}`}
//               >
//                 <div className={`w-6 h-6 rounded-md border flex items-center justify-center mr-4 transition-colors ${includeWebinar ? 'bg-emerald-accent border-emerald-accent' : 'border-zinc-600'}`}>
//                   {includeWebinar && <span className="text-charcoal text-xs font-bold">✓</span>}
//                 </div>
//                 <div className="flex-1">
//                   <p className="font-medium">+ Recorded Webinar Lectures</p>
//                 </div>
//                 <span className="font-bold text-emerald-accent">+ ₹{prices.webinar}</span>
//               </div>

//               <div className="mt-8 pt-6 border-t border-zinc-800 flex justify-between items-center">
//                 <span className="text-zinc-400">Total Due:</span>
//                 <span className="text-3xl font-bold text-emerald-accent">₹{total}</span>
//               </div>

//               <button 
//                 type="submit" 
//                 disabled={isLoading} 
//                 className="w-full py-4 mt-8 bg-emerald-accent text-charcoal font-bold rounded-2xl hover:bg-emerald-400 transition-all transform active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed touch-manipulation"
//               >
//                 {isLoading ? (
//                   <div className="flex items-center justify-center gap-2">
//                     <div className="w-5 h-5 border-2 border-charcoal border-t-transparent rounded-full animate-spin"></div>
//                     <span>Securing Gateway...</span>
//                   </div>
//                 ) : 'Continue'}
//               </button>
//             </form>
//           </div>
//         )}

//         {view === 'upsell' && (
//           <div className="animate-fade-in-up bg-dark-grey rounded-3xl p-10 text-center mt-10 border border-emerald-500/20 shadow-2xl">
//             <span className="inline-block p-4 bg-emerald-accent/10 rounded-full mb-6">🛑</span>
//             <h2 className="text-3xl font-bold mb-4">Wait! Want to 10x your results?</h2>
//             <p className="text-zinc-400 mb-8 leading-relaxed">Most community members include the <strong>Webinar Recorded Lectures</strong> to get started faster. Add it now for just ₹{prices.webinar}!</p>

//             <button 
//               onClick={() => handleUpsellChoice(true)}
//               disabled={isLoading}
//               className="w-full py-4 bg-emerald-accent text-charcoal font-bold rounded-2xl mb-4 text-lg active:scale-95 transition-transform disabled:opacity-70 touch-manipulation cursor-pointer"
//             >
//               {isLoading ? 'Processing Upgrade...' : `Yes, Upgrade & Pay ₹${prices.whatsapp + prices.webinar}`}
//             </button>

//             <button 
//               onClick={() => handleUpsellChoice(false)} 
//               disabled={isLoading}
//               className="w-full py-4 text-zinc-500 font-medium active:text-zinc-300 disabled:opacity-50 touch-manipulation cursor-pointer"
//             >
//               {isLoading ? 'Connecting...' : `No thanks, stick to ₹${prices.whatsapp}`}
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FormPage;


//INSTAMOJO

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import KBLogo from './KBLogo';
import axios from 'axios';

const FormPage = () => {
  const navigate = useNavigate();

  const [view, setView] = useState('form'); 
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
  const [includeWebinar, setIncludeWebinar] = useState(false);
  const [errors, setErrors] = useState({});

  const [prices, setPrices] = useState({
    whatsapp: 99,
    webinar: 149,
    isEnabled: true
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://fitnessfreak-44cu.onrender.com";
        const res = await axios.get(`${API_BASE}/api/settings`);
        if (res.data) {
          setPrices({
            whatsapp: res.data.livePrice || 99,
            webinar: res.data.webinarPrice || 149,
            isEnabled: res.data.isPaymentEnabled
          });

          if (res.data.isPaymentEnabled === false) {
            alert("Payments are currently disabled.");
            navigate('/');
          }
        }
      } catch (err) {
        console.error("Error fetching pricing", err);
      }
    };
    fetchSettings();
  }, [navigate]);

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView'); 
      window.fbq('track', 'AddToCart', {
        content_name: 'Fitness Community + Webinar Access',
        content_ids: ['community_01'],
        content_type: 'product',
        value: prices.whatsapp,
        currency: 'INR'
      });
      console.log("🚀 Meta Pixel: AddToCart Triggered");
    }
  }, [prices.whatsapp]);

  const total = includeWebinar ? prices.whatsapp + prices.webinar : prices.whatsapp;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim() || !/^[0-9]{10}$/.test(formData.phone.trim())) newErrors.phone = 'Enter 10-digit phone';
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) newErrors.email = 'Valid email required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const initializePayment = async (isUpgraded) => {
  setIsLoading(true);

  // 1. Calculate the actual final price
  const finalPrice = isUpgraded ? (prices.whatsapp + prices.webinar) : prices.whatsapp;
  
  // 2. Make the name specific to the price
  const productName = isUpgraded ? 'Community + Webinar Access' : 'Community Access Only';

  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: productName, 
      value: finalPrice,         
      currency: 'INR',
      num_items: 1
    });
    console.log(`🚀 Meta Pixel: InitiateCheckout for ${productName} at ₹${finalPrice}`);
  }

  try {
    const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://fitnessfreak-44cu.onrender.com";
    const response = await axios.post(`${API_BASE}/api/verify-and-pay`, {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      includeWebinar: isUpgraded
    });

    if (response.data.paymentUrl) {
      window.location.href = response.data.paymentUrl;
    } else {
      alert('Payment failed to initialize.');
      setIsLoading(false);
    }
  } catch (error) {
    console.error("Payment Error:", error);
    alert('Network error or Gateway busy. Please try again.');
    setIsLoading(false);
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!includeWebinar) {
      if (window.fbq) {
        window.fbq('trackCustom', 'ViewedUpsell');
      }
      setView('upsell'); 
    } else {
      initializePayment(true);
    }
  };

  const handleUpsellChoice = async (upgrade) => {
    setIsLoading(true); // Give UI feedback IMMEDIATELY before async actions
    setIncludeWebinar(upgrade);
    await initializePayment(upgrade);
  };

  return (
    <div className="bg-charcoal min-h-screen py-8 px-4 text-white">
      <header className="max-w-2xl mx-auto flex items-center justify-between mb-8">
        <button 
          onClick={() => view === 'form' ? navigate('/') : setView('form')} 
          disabled={isLoading}
          className="text-zinc-400 hover:text-white transition-colors disabled:opacity-50 touch-manipulation cursor-pointer"
        >
          ← Back
        </button>
        <KBLogo size={40} />
      </header>

      <div className="max-w-2xl mx-auto">
        {view === 'form' && (
          <div className="animate-fade-in-up bg-dark-grey rounded-3xl p-6 md:p-10 border border-zinc-800 shadow-2xl">
            <h1 className="text-2xl font-bold mb-8">Join the Community</h1>
            <form onSubmit={handleSubmit}>
              <div className="space-y-4 mb-8">
                <div>
                  <label className="text-sm text-zinc-400 block mb-2">Full Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="Your Name" />
                  {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                </div>
                <div>
                  <label className="text-sm text-zinc-400 block mb-2">Phone Number</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="10 Digit Number" />
                  {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                </div>
                <div>
                  <label className="text-sm text-zinc-400 block mb-2">Email Address</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 focus:border-emerald-accent outline-none" placeholder="example@email.com" />
                  {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                </div>
              </div>

              <h2 className="text-lg font-semibold mb-4 text-zinc-300">Select Package</h2>

              <div className="flex items-center bg-zinc-900/50 rounded-2xl p-4 border border-zinc-800 mb-3 opacity-90">
                <div className="w-6 h-6 rounded-md bg-emerald-accent/20 border border-emerald-accent/50 flex items-center justify-center mr-4">
                  <div className="w-2 h-2 bg-emerald-accent rounded-full"></div>
                </div>
                <div className="flex-1">
                  <p className="font-medium">WhatsApp Community Access</p>
                </div>
                <span className="font-bold">₹{prices.whatsapp}</span>
              </div>

              <div 
                onClick={() => !isLoading && setIncludeWebinar(!includeWebinar)}
                className={`flex items-center rounded-2xl p-4 border-2 cursor-pointer touch-manipulation transition-all ${includeWebinar ? 'bg-emerald-accent/5 border-emerald-accent' : 'bg-zinc-900/50 border-zinc-800 hover:border-zinc-600'}`}
              >
                <div className={`w-6 h-6 rounded-md border flex items-center justify-center mr-4 transition-colors ${includeWebinar ? 'bg-emerald-accent border-emerald-accent' : 'border-zinc-600'}`}>
                  {includeWebinar && <span className="text-charcoal text-xs font-bold">✓</span>}
                </div>
                <div className="flex-1">
                  <p className="font-medium">+ Recorded Webinar Lectures</p>
                </div>
                <span className="font-bold text-emerald-accent">+ ₹{prices.webinar}</span>
              </div>

              <div className="mt-8 pt-6 border-t border-zinc-800 flex justify-between items-center">
                <span className="text-zinc-400">Total Due:</span>
                <span className="text-3xl font-bold text-emerald-accent">₹{total}</span>
              </div>

              <button 
                type="submit" 
                disabled={isLoading} 
                className="w-full py-4 mt-8 bg-emerald-accent text-charcoal font-bold rounded-2xl hover:bg-emerald-400 transition-all transform active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed touch-manipulation"
              >
                {isLoading ? (
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-5 h-5 border-2 border-charcoal border-t-transparent rounded-full animate-spin"></div>
                    <span>Securing Gateway...</span>
                  </div>
                ) : 'Continue'}
              </button>
            </form>
          </div>
        )}

        {view === 'upsell' && (
          <div className="animate-fade-in-up bg-dark-grey rounded-3xl p-10 text-center mt-10 border border-emerald-500/20 shadow-2xl">
            <span className="inline-block p-4 bg-emerald-accent/10 rounded-full mb-6">🛑</span>
            <h2 className="text-3xl font-bold mb-4">Wait! Want to 10x your results?</h2>
            <p className="text-zinc-400 mb-8 leading-relaxed">Most community members include the <strong>Webinar Recorded Lectures</strong> to get started faster. Add it now for just ₹{prices.webinar}!</p>

            <button 
              onClick={() => handleUpsellChoice(true)}
              disabled={isLoading}
              className="w-full py-4 bg-emerald-accent text-charcoal font-bold rounded-2xl mb-4 text-lg active:scale-95 transition-transform disabled:opacity-70 touch-manipulation cursor-pointer"
            >
              {isLoading ? 'Processing Upgrade...' : `Yes, Upgrade & Pay ₹${prices.whatsapp + prices.webinar}`}
            </button>

            <button 
              onClick={() => handleUpsellChoice(false)} 
              disabled={isLoading}
              className="w-full py-4 text-zinc-500 font-medium active:text-zinc-300 disabled:opacity-50 touch-manipulation cursor-pointer"
            >
              {isLoading ? 'Connecting...' : `No thanks, stick to ₹${prices.whatsapp}`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormPage;



//COSMOFEED

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import KBLogo from './KBLogo';

// const FormPage = () => {
//   const navigate = useNavigate();

//   const [view, setView] = useState('form'); 
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
//   const [includeWebinar, setIncludeWebinar] = useState(false);
//   const [errors, setErrors] = useState({});


//   const COMMUNITY_LINK = "https://superprofile.bio/vp/69ec8f045fe24c0013a3881a"; 
//   const BUNDLE_LINK = "https://superprofile.bio/vp/69ec9119ddd54d0013548672"; 

//   const prices = {
//     whatsapp: 99,
//     webinar: 149
//   };

//   const total = includeWebinar ? prices.whatsapp + prices.webinar : prices.whatsapp;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.phone.trim() || !/^[0-9]{10}$/.test(formData.phone.trim())) newErrors.phone = 'Enter 10-digit phone';
//     if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) newErrors.email = 'Valid email required';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const initializePayment = (isUpgraded) => {
//     setIsLoading(true);

//     const finalLink = isUpgraded ? BUNDLE_LINK : COMMUNITY_LINK;

 
//     if (window.fbq) {
//       window.fbq('track', 'InitiateCheckout', {
//         content_name: isUpgraded ? 'Community + Webinar' : 'Community Only',
//         value: isUpgraded ? total : prices.whatsapp,
//         currency: 'INR'
//       });
//     }


//     window.location.href = finalLink;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     if (!includeWebinar) {
//       if (window.fbq) {
//         window.fbq('trackCustom', 'ViewedUpsell');
//       }
//       setView('upsell'); 
//     } else {
//       initializePayment(true);
//     }
//   };

//   const handleUpsellChoice = (upgrade) => {
//     setIncludeWebinar(upgrade);
//     initializePayment(upgrade);
//   };

//   return (
//     <div className="bg-charcoal min-h-screen py-8 px-4 text-white">
//       <header className="max-w-2xl mx-auto flex items-center justify-between mb-8">
//         <button 
//           onClick={() => view === 'form' ? navigate('/') : setView('form')} 
//           disabled={isLoading}
//           className="text-zinc-400 hover:text-white transition-colors disabled:opacity-50"
//         >
//           ← Back
//         </button>
//         <KBLogo size={40} />
//       </header>

//       <div className="max-w-2xl mx-auto">

//         {/* ================= FORM ================= */}
//         {view === 'form' && (
//           <div className="bg-dark-grey rounded-3xl p-6 md:p-10 border border-zinc-800 shadow-2xl">
//             <h1 className="text-2xl font-bold mb-8">Join the Community</h1>

//             <form onSubmit={handleSubmit}>
//               <div className="space-y-4 mb-8">

//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Full Name</label>
//                   <input type="text" name="name" value={formData.name} onChange={handleChange}
//                     className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 outline-none"
//                     placeholder="Your Name" />
//                   {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
//                 </div>

//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Phone Number</label>
//                   <input type="tel" name="phone" value={formData.phone} onChange={handleChange}
//                     className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 outline-none"
//                     placeholder="10 Digit Number" />
//                   {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
//                 </div>

//                 <div>
//                   <label className="text-sm text-zinc-400 block mb-2">Email Address</label>
//                   <input type="email" name="email" value={formData.email} onChange={handleChange}
//                     className="w-full p-4 bg-zinc-900 rounded-xl border border-zinc-700 outline-none"
//                     placeholder="example@email.com" />
//                   {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
//                 </div>

//               </div>

//               <h2 className="text-lg font-semibold mb-4 text-zinc-300">Select Package</h2>

//               {/* Base Plan */}
//               <div className="flex items-center bg-zinc-900/50 rounded-2xl p-4 border border-zinc-800 mb-3">
//                 <div className="flex-1">
//                   <p className="font-medium">WhatsApp Community Access</p>
//                 </div>
//                 <span className="font-bold">₹{prices.whatsapp}</span>
//               </div>

//               {/* Add-on */}
//               <div 
//                 onClick={() => !isLoading && setIncludeWebinar(!includeWebinar)}
//                 className={`flex items-center rounded-2xl p-4 border-2 cursor-pointer transition-all ${
//                   includeWebinar ? 'bg-emerald-accent/5 border-emerald-accent' : 'bg-zinc-900/50 border-zinc-800'
//                 }`}
//               >
//                 <div className="flex-1">
//                   <p className="font-medium">+ Recorded Webinar Lectures</p>
//                 </div>
//                 <span className="font-bold text-emerald-accent">+ ₹{prices.webinar}</span>
//               </div>

//               <div className="mt-8 pt-6 border-t border-zinc-800 flex justify-between items-center">
//                 <span>Total:</span>
//                 <span className="text-3xl font-bold text-emerald-accent">₹{total}</span>
//               </div>

//               <button type="submit" disabled={isLoading}
//                 className="w-full py-4 mt-8 bg-emerald-accent text-black font-bold rounded-2xl">
//                 {isLoading ? "Redirecting..." : "Continue"}
//               </button>
//             </form>
//           </div>
//         )}

//         {/* ================= UPSELL ================= */}
//         {view === 'upsell' && (
//           <div className="bg-dark-grey rounded-3xl p-10 text-center border border-emerald-500/20">
//             <h2 className="text-3xl font-bold mb-4">Wait! Upgrade your results 🚀</h2>
//             <p className="text-zinc-400 mb-8">
//               Add Webinar Access for just ₹{prices.webinar}
//             </p>

//             <button 
//               onClick={() => handleUpsellChoice(true)}
//               disabled={isLoading}
//               className="w-full py-4 bg-emerald-accent text-black font-bold rounded-2xl mb-4"
//             >
//               Yes, Pay ₹{prices.whatsapp + prices.webinar}
//             </button>

//             <button 
//               onClick={() => handleUpsellChoice(false)}
//               disabled={isLoading}
//               className="w-full py-4 text-zinc-500"
//             >
//               No, Pay ₹{prices.whatsapp}
//             </button>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default FormPage;

